import React from 'react'
import './format.css'
import QuranFormat from './format'
export default function Quranformats() {
 
  return (
    <div>
         <div className='newcomp-container' style={{ textDecoration: 'none' }}>
        <QuranFormat title="Get Quran by Surah " content=" Get Holy Quran by Surah with English Translation and recitation here" linkTo="/BySurah" />
        <QuranFormat title="Get Quran by Juz/Parah" content=" Get Holy Quran by Juz/Parah with English Translation and recitation here" linkTo='/ByJuz' />
      </div>
    </div>
  )
}
